import { render, staticRenderFns } from "./MessagePreviewModal.vue?vue&type=template&id=57b72a9e"
import script from "./MessagePreviewModal.vue?vue&type=script&lang=js"
export * from "./MessagePreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports